import React from 'react';
import { RouteComponentProps, withRouter, StaticContext } from 'react-router';
import { BrowserRedirect } from '@catalogo/core-browser-redirect';
import { WithRouterStatics } from 'react-router';

export interface StatusCodeProps extends RouteComponentProps {
  status: number;
  url?: string;
  staticContext?: CustomStaticContext;
}

export interface CustomStaticContext extends StaticContext {
  status: number;
  url?: string;
}

const StatusCodeComponent: React.FC<StatusCodeProps> = props => {
  const { staticContext, status, url } = props;
  if (staticContext) {
    staticContext.status = status;

    if (url) {
      staticContext.url = url;
    }

    return null;
  }

  return <BrowserRedirect url={url} />;
};
export const StatusCode: React.ComponentClass<Pick<StatusCodeProps, 'status' | 'url'>> &
  WithRouterStatics<React.FC<StatusCodeProps>> = withRouter(StatusCodeComponent);
